export * from './employeeEligibilityReport.component';
export * from './employeeEligibilityReport.service';
export * from './empeligibleworkdetail';



// WEBPACK FOOTER //
// ./src/app/EmployeeEligibilityReport/index.ts